import {useSelector} from 'react-redux';

import {portIncidentAPI} from 'features/port/api/portIncidentAPI';
import {ILastIncidents} from 'entities/monitor';
import {userSelector} from 'entities/user';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IPortIncident from './PortIncident/IPortIncident';

export interface ILastPortIncidents extends ILastIncidents<IPortIncident> {
    tzString: string | null | undefined,
}

export const useLastPortIncidents = (limit: number): ILastPortIncidents => {
    const user = useSelector(userSelector);

    const {data: pagination, isLoading, isFetching} = portIncidentAPI.useGetPortIncidentsQuery(
        {limit},
        {pollingInterval: getPollingInterval()},
    );

    return {pagination, isLoading, isFetching, tzString: user?.timezone};
};

export default useLastPortIncidents;
